import { render, staticRenderFns } from "./DetailProgramPemilikSistem.vue?vue&type=template&id=6e522bc6&scoped=true&"
import script from "./DetailProgramPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./DetailProgramPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e522bc6",
  null
  
)

export default component.exports